import React from 'react';
import {Platform} from 'react-native';
import { string, array, func, number } from 'prop-types';
import NativePicker from './NativePicker';
//import WebPicker from './WebPicker';

//const Picker = (props) => Platform.OS === 'web' ? <WebPicker {...props} /> : <NativePicker {...props} />;
const Picker = (props) => <NativePicker {...props} />;

Picker.propTypes = {
  currentValue: string.isRequired,
  onChange: func.isRequired,
  options: array.isRequired,
  style: number,
};

export default Picker;
